// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607310602/js/" + chunkId + "." + {"44":"c6ac4574","225":"25004d7b","481":"8056d100","486":"c3f7f5ed","770":"0c742c4c"}[chunkId] + ".0.933614207156868.chunk.js";
};